export function getCurrentPath(router) {
    if (router !== undefined && (router === null || router === void 0 ? void 0 : router.asPath)) {
        return router.asPath;
    }
    else if (typeof window !== "undefined") {
        return window.location.pathname;
    }
    return "/";
}
export function getItems(items, navHistory) {
    if (navHistory.length === 1)
        return items;
    let r = [...items];
    navHistory.forEach((i) => {
        var _a;
        if (i.title && r)
            r = ((_a = r[i.tabIndex]) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
    return r || [];
}
export function isMenuItemActive(item, currentPath) {
    if (item.url === currentPath)
        return true;
    if (item.children) {
        return item.children.some((child) => isMenuItemActive(child, currentPath));
    }
    return false;
}
export function findNavHistoryForPath(items, path, history = [{ level: 0, tabIndex: 0, title: "" }], level = 0) {
    let foundHistory = null;
    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.url === path) {
            let finalHistory = [
                ...history,
                { level: level, tabIndex: i, title: item.title },
            ];
            finalHistory.pop(); // Removing the last element which is the actual current page
            return finalHistory;
        }
        if (item.items && item.items.length) {
            let nestedHistory = findNavHistoryForPath(item.items, path, [...history, { level: level, tabIndex: i, title: item.title }], level + 1);
            if (nestedHistory && nestedHistory.length > history.length) {
                foundHistory = nestedHistory;
            }
        }
    }
    if (foundHistory) {
        return foundHistory;
    }
    return [];
}
